import React, { useContext, useEffect, useState } from 'react'
import './Navbar.css';
import { FaUser } from 'react-icons/fa';
import { AuthContext } from "../../context/AuthContext";
import { NavLink } from 'react-router-dom';

const logo = require('../../assets/logo.png')

function TopBar({ data }) {
    // console.log("Check data Nabar--->",data)
    const [menuOpen, setMenuOpen] = useState(false)
    const [openDropdown, setOpenDropdown] = useState(null);
    const { userData, logout } = useContext(AuthContext);

    const toggleDropdown = (menu) => {
        setOpenDropdown(openDropdown === menu ? null : menu);
    };

    return (
        <header style={{ width: '100vw' }}>
        <nav onClick={() => setMenuOpen(!menuOpen)}>
          <NavLink to={userData?.user_type !== 1 ?  "/Home" : "/CMS" }>
            <img src={logo} style={{ padding: 5, width: 60, height: "auto" }} alt="Logo" />
          </NavLink>
      
          {/* Nút menu cho mobile */}
          <div className="menu" onClick={() => setMenuOpen(!menuOpen)}>
            <span></span>
            <span></span>
            <span></span>
          </div>
      
          {/* Menu */}
          <ul className={menuOpen ? "open" : ""}>
            {userData?.user_type !== 1 && (
              <>
                <li>
                  <NavLink to="/Home">Trang chủ</NavLink>
                </li>
                <li>
                  <NavLink to="/News">Tin tức</NavLink>
                </li>
                {/* Dropdown Dịch vụ */}
                <li className={`dropdown ${openDropdown === "services" ? "active" : ""}`}>
                  <NavLink to="#">Dịch vụ</NavLink>
                  <ul className={`dropdown-menu ${openDropdown === "services" ? "show" : ""}`}>
                    <li>
                      <NavLink to="/ProDuct">Sản phẩm</NavLink>
                    </li>
                    <li>
                      <NavLink to="/Search">Tra Cứu</NavLink>
                    </li>
                  </ul>
                </li>
                <li>
                  <NavLink to="/News">Thiện nguyện</NavLink>
                </li>
                <li>
                  <NavLink to="/News">Giới thiệu</NavLink>
                </li>
                <li>
                  <NavLink to="/News">Liên hệ</NavLink>
                </li>
                {/* Quản lý người dùng (chỉ hiển thị nếu user_type == 1) */}
              </>
            )}
      
            {/* Dropdown Profile */}
            <li className={`dropdown ${openDropdown === "profile" ? "active" : ""}`}>
              <div className="profile">
                <FaUser className="icon" />
                <NavLink to="#">{userData?.user_fullname}</NavLink>
              </div>
              <ul className={`dropdown-menu ${openDropdown === "profile" ? "show" : ""}`}>
                <li>
                  <NavLink to="/Profile">Cá nhân</NavLink>
                </li>
                <li>
                  <NavLink onClick={logout} to="/">
                    Đăng xuất
                  </NavLink>
                </li>
              </ul>
            </li>
          </ul>
        </nav>
      </header>
      
    );
}

export default TopBar;